import { create } from "zustand";
import type { Person } from "@/entities/person";
import { useSupplierPersonStore } from "@/features/supplier/model/useSupplierPersonStore";

interface PersonStore {
  persons: Person[];

  isAddPersonFormOpen: boolean;
  setIsAddPersonFormOpen: (isOpen: boolean) => void;

  editPersonId: string;
  setEditPersonId: (id: string) => void;

  setPersons: (persons: Person[]) => void;
  addPerson: (person: Person) => void;
  updatePerson: (id: string, person: Partial<Person>) => void;
  deletePerson: (id: string) => void;
  getPersonsByTenant: (tenantId: string) => Person[];
  getPersonByEmployeeId: (employeeId: string) => Person | undefined;
}

export const usePersonStore = create<PersonStore>((set, get) => ({
  persons: [],
  isAddPersonFormOpen: false,
  setIsAddPersonFormOpen: (isOpen) => set({ isAddPersonFormOpen: isOpen }),

  editPersonId: '',
  setEditPersonId: (id: string) => set({ editPersonId: id }),


  setPersons: (persons) => set({ persons }),
  addPerson: (person) => set((state) => ({ persons: [...state.persons, person] })),
  updatePerson: (id, updatedPerson) =>
    set((state) => ({
      persons: state.persons.map((p) => (p.id === id ? { ...p, ...updatedPerson } : p)),
    })),
  deletePerson: (id) => {
    const { deleteSupplierPersonsByPerson } = useSupplierPersonStore.getState();
    deleteSupplierPersonsByPerson(id);

    set((state) => ({ persons: state.persons.filter((p) => p.id !== id) }));
  },
  getPersonsByTenant: (tenantId) => get().persons.filter((p) => p.tenant_id === tenantId),
  getPersonByEmployeeId: (employeeId) => 
    get().persons.find((p) => p.employee_id === employeeId),
}));
